import { cn } from "@/lib/utils";
import {
  DAGCanvas,
  Path,
} from "@/pages/DetailedPlayer/sections/Evolutions/DAGCanvas";
import { evolutionsSelector } from "@/redux/evolutions/evolutionsSlice";
import { useMemo } from "react";
import { useSelector } from "react-redux";

interface EvolutionTreeProps {
  evolutionTree?: any;
  handleNodeClicked?: (nodeId: string) => void;
  chosenPath?: Path | null;
}

export const EvolutionTree = ({
  evolutionTree,
  handleNodeClicked,
  chosenPath,
}: EvolutionTreeProps) => {
  const { evolutions } = useSelector(evolutionsSelector);

  const evolutionMap = useMemo(() => {
    const map: Record<number, string> = {};
    for (const evo of evolutions) {
      map[evo.id] = evo.name;
    }
    return map;
  }, [evolutions, evolutionTree]);

  return (
    <div
      className={cn(
        "w-full bg-new-gray-900 h-96 border-b border-panel-middleground",
      )}
    >
      <div className="relative">
        <DAGCanvas
          chosenPath={chosenPath}
          tree={evolutionTree}
          evolutionMap={evolutionMap}
          handleNodeClicked={handleNodeClicked}
        />
      </div>
    </div>
  );
};
